import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { GetProductsRequestPost, Product, ProductsUtils } from '../../common';

@Component({
    selector: 'ca-product-tile',
    templateUrl: './product-tile.component.html',
    styleUrls: ['./product-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductTileComponent {
    readonly placeholderImageSrc = ProductsUtils.placeholderImageSrc;
    product = input.required<Product>();
    languageCode = input.required<GetProductsRequestPost['languageCode']>();
    countryCode = input.required<GetProductsRequestPost['countryCode']>();
    isSelected = input<boolean>(false);
    allowedProductTypes = input<Product['productType'][]>();
    allowDifferentProductTypeSelection = input<boolean>(true);
    selectProduct = output<Product>();

    isDifferentProductType = computed(() => {
        if (this.allowDifferentProductTypeSelection()) return false;
        const allowedProductTypes = this.allowedProductTypes();
        if (!allowedProductTypes) return false;
        const product = this.product();
        return allowedProductTypes.length > 0 && !allowedProductTypes.includes(product.productType);
    });
}
